import debounce from '../utils/debounce'; 

const masthead = {
  submenus: document.querySelectorAll('.nav > .nav-item > .nav-item-link.menu-item-has-children'),
  submenuArrows: document.querySelectorAll('.nav > .nav-item > .nav-item-link.menu-item-has-children > .nav-item-link-arrow'),
  handleMobileToggle: () => {
    const siteNavigationToggle = document.getElementById("site-navigation-toggle");
    siteNavigationToggle.addEventListener('keypress', function(e) {
      e.preventDefault();
      if (e.code === "Enter" || e.code === "Space") {
        siteNavigationToggle.click();
      }
    });
  },
  handleMobileDropdowns: (e) => {
    const target = e.target;
    if (!e.target.classList.contains('open')) {
      e.preventDefault();
      target.classList.toggle('open');  
    }
  },
  handleMobileDropdownArrows: (e) => {
    e.preventDefault();
    const target = e.target;
    target.parentElement.classList.toggle('open');
  },
  handleMobileDropdownsKeyboard: (e) => {
    if (e.code === "Enter" || e.code === "Space") {
      masthead.handleMobileDropdowns(e);
    }
  },
  initMobileDropdowns: () => {
    if (window.innerWidth < 1025) {
      for (let index = 0; index < masthead.submenuArrows.length; index++) {
        const element = masthead.submenuArrows[index];
        element.addEventListener('click', masthead.handleMobileDropdownArrows);
      }
      for (let index = 0; index < masthead.submenus.length; index++) {
        const element = masthead.submenus[index];
        element.addEventListener('click', masthead.handleMobileDropdowns);
        element.addEventListener('keypress', masthead.handleMobileDropdownsKeyboard);
      }
    }
  },
  init: () => {
    masthead.handleMobileToggle();
    masthead.initMobileDropdowns();
    window.addEventListener('resize', debounce(() => {
      for (let index = 0; index < masthead.submenuArrows.length; index++) {
        const element = masthead.submenuArrows[index];
        element.removeEventListener('click', masthead.handleMobileDropdownArrows);
      }
      for (let index = 0; index < masthead.submenus.length; index++) {
        const element = masthead.submenus[index];
        element.classList.remove('open');
        element.removeEventListener('click', masthead.handleMobileDropdowns);
        element.removeEventListener('keypress', masthead.handleMobileDropdownsKeyboard);
      }
      masthead.initMobileDropdowns();
    }, 300));
  }
}

export default masthead;